import cx from 'classnames'

import { Alert } from '@/components/Icons'

import styles from './Common.module.scss'

export const RowAlert: React.FC<{ content: string; className?: string }> = ({ content, className }) => (
  <div className={cx(styles.RowAlert, className)}>
    <Alert type="default" />
    {content}
  </div>
)
